import React from 'react'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'

type StreamingBannerProps = {
  banner: HeroBannerData
}

export const GenericBanner: React.FC<StreamingBannerProps> = () => {
  // these technically exist but have never been used, we'll need to work out the spec
  return null
}
